export const MONTHS = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
export const DOW = ["M", "T", "W", "T", "F", "S", "S"]; // Mon-first

export function pad(n) { return String(n).padStart(2, "0"); }
export function dateStr(y, m, d) { return `${y}-${pad(m + 1)}-${pad(d)}`; }
export function daysInMonth(y, m) { return new Date(y, m + 1, 0).getDate(); }
// Convert JS getDay (0=Sun..6=Sat) to Mon=0..Sun=6
export function mondayDow(d) { return (d.getDay() + 6) % 7; }

// Relative date label for date chips on search results
export function relLabel(dateStr, todayKey) {
    if (!dateStr) return null;
    try {
        const d = new Date(dateStr + "T12:00:00");
        const t = new Date(todayKey + "T12:00:00");
        const diff = Math.round((d - t) / 86400000);
        if (diff === 0) return "today";
        if (diff === 1) return "tomorrow";
        if (diff === -1) return "yesterday";
        const wd = d.toLocaleDateString(undefined, { weekday: "short" });
        if (diff > 1 && diff <= 6) return wd;
        if (diff < -1 && diff >= -6) return `last ${wd}`;
        const opts = d.getFullYear() === t.getFullYear()
            ? { month: "short", day: "numeric" }
            : { month: "short", day: "numeric", year: "numeric" };
        return d.toLocaleDateString(undefined, opts);
    } catch {
        return dateStr;
    }
}
